import React from 'react';
import WysiwygEditor from './WysiwygEditor';
import { cn } from '@/lib/utils';

export interface MarkdownEditorProps {
  value?: string;
  onChange?: (value: string | undefined) => void;
  onBlur?: () => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  /** @deprecated No longer used – kept for API compatibility */
  preview?: 'edit' | 'live' | 'preview';
  /** Pixels, or any CSS length. */
  height?: number | string;
  error?: boolean;
}

const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
  value = '',
  onChange,
  onBlur,
  // Left undefined so WysiwygEditor falls back to its translated default placeholder.
  placeholder,
  className,
  disabled = false,
  height = 200,
  error = false,
}) => {
  const handleChange = (val: string) => {
    if (onChange) {
      onChange(val);
    }
  };

  return (
    <WysiwygEditor
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      placeholder={placeholder}
      className={cn(className)}
      disabled={disabled}
      minHeight={height}
      error={error}
    />
  );
};

export default MarkdownEditor;
